import React, {
  useCallback,
  useRef,
  useState,
} from "react";

import { Box, Button, Dialog, Stack, Tooltip, Typography } from "@mui/material";
import { CrumbToggleScenario } from "./CrumbToggles.jsx";
import { errorJsonHasErrors, errorCheckForm } from "./Inputs/Input_Fns.jsx";
import { ErrorBar } from "./ErrorBar.jsx";
import DialogDelete from "./DialogDelete.jsx";
import HelpIcon from "../Dialogs/Help/HelpIcon.jsx";
import { HelpAddAccount } from "../Dialogs/Help/Help_AddAccount.jsx";
import CloseIcon from "./CloseIcon.jsx";
import { useReactToPrint } from "react-to-print";
import { GoogleAnalyticsEvent } from "./ga4.jsx";
import { PrintPage } from "./PrintPage.jsx";




export const AddDialog = ({
  clientJson,
  c_callback,
  open,
  onClose,
  label,
  accountType,
  subtype = "",
  client,
  clients,
  onClientChange,
  onSubmit,
  submitTooltip = "",
  deleted,
  errors,
  errmsg = "",
  children,
  locked = null,
  extraButton = null,
  onExtraButton = null,
  extraButtonTooltip = "",
  noButtons = false,
  noSubmit = false,
  ExtraIcon1 = null,
  PrintFileName = null,
}) => {
  const [diaDelete, setDiaDelete] = useState(false)
  const [scenInputs, setScenInputs] = useState({})

  const textRef = useRef(null);
  const reactToPrintFn = useCallback(useReactToPrint({
    documentTitle: PrintFileName,
    contentRef: textRef,
  }), [PrintFileName])


  const mySubmit = () => {
    //console.log(errors)
    errorCheckForm()
    if (!errorJsonHasErrors(errors)) {
      if (deleted) {
        setDiaDelete(true)
      } else {
        onSubmit()
      }
    }
  }

  const myExtraSubmit = () => {
    errorCheckForm()
    if (!errorJsonHasErrors(errors)) {
      if (deleted) {
        setDiaDelete(true)
      } else {
        onExtraButton()
      }
    }
  }

  const okSubmit = () => {
    onSubmit()
  }


  const myPrint = () => {
    if (textRef.current) {
      reactToPrintFn()
      GoogleAnalyticsEvent("input", "text", "scenario", { action: "print", type: "scenario" })
    }
  }

  const myClose = (event, reason) => {
    if (reason !== 'escapeKeyDown') {
      onClose()
    }
  }


  return (
    <>
      {open && (
        <Dialog
          sx={{
            overflow: "scroll",
            "& .MuiDialog-container": {
              display: "inline-flex !important",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              overflow: "scroll",
              mt: 30,
              mx: 30,
            },
          }}
          fullWidth={true}
          maxWidth="100%"
          open={open}
          onClose={myClose}
        >
          <Stack sx={{ mx: 4, my: 4 }} spacing={2}>
            <Stack direction="row" sx={{ mb: 6 }} spacing={2}>
              {noButtons === false && (
                <>
                  <Button variant="contained" color="secondary" onClick={onClose}>
                    Cancel
                  </Button>
                  {!noSubmit &&
                    <Tooltip title={submitTooltip}>
                      <Button
                        variant="contained"
                        // locked === null is normal screens, 
                        // locked === false is for client screen to allow unlocking a readonly client
                        // locked === true the client is locked anyway and readonly would be true
                        disabled={clientJson !== null && (clientJson.readonly || clientJson.Scenario.readonly) &&
                          (locked === null || locked)}
                        onClick={mySubmit}
                      >
                        Submit
                      </Button>
                    </Tooltip>
                  }
                  {extraButton && (
                    <Tooltip title={extraButtonTooltip}>
                      <Button variant="contained" onClick={myExtraSubmit}>
                        {extraButton}
                      </Button>
                    </Tooltip>
                  )}
                </>
              )}
              <Box
                sx={{
                  display: "flex",
                  flexGrow: 1,
                  alignContent: "center",
                  justifyContent: "flex-end"
                }}
              >
                <Stack direction="row" spacing={2}>
                  {ExtraIcon1 !== null &&
                    <ExtraIcon1 />
                  }
                  {PrintFileName !== null &&
                    <PrintPage
                      tooltip="Print Input Summary"
                      onPrint={myPrint} />
                  }
                  <HelpIcon />
                  <CloseIcon
                    onClick={onClose}
                  />
                </Stack>
              </Box>
            </Stack>

            <Box >
              <Stack
                direction="row"
                sx={{ mt: 2, mb: 2, alignContent: "center" }}
                spacing={2}
              >
                {clients && (
                  <CrumbToggleScenario
                    set={clients}
                    current={client}
                    clientJson={clientJson}
                    onChange={onClientChange}
                    crumbClose={(json) => {
                      c_callback(json);
                      onClose();
                    }}
                  />
                )}

                <Typography id="s-die-age-slider" variant="h6" gutterBottom>
                  {label}
                </Typography>
                <div className="align-right"></div>
              </Stack>
            </Box>
          </Stack>
          <div ref={textRef}>
            {children}
          </div>
          <DialogDelete
            show={diaDelete}
            onClose={() => setDiaDelete(false)}
            query="Some items were deleted, Do you wish to continue submitting"
            deleteName="Submit"
            onDelete={okSubmit}
          />
          <HelpAddAccount account={accountType} subtype={subtype} />
          <ErrorBar error={errmsg} />
        </Dialog>
      )}
    </>
  );
};
